import withStyles from 'isomorphic-style-loader/lib/withStyles';
import React from 'react';

import PageLayout from '../../../../components/PageLayout';

import s from './CareersPage.scss';

function CareersPage() {
  return (
    <PageLayout className={s.page}>
      <div className={s.banner}>
        <div className={s.bannerContent}>
          <h2>Careers</h2>
          <span>
            <img alt="logo" src="/assets/images/about/icons/logo-white.svg" />
          </span>
          <p>
            We are looking for team members who want to help us make education
            accessible, effective and affordable for everyone.
          </p>
        </div>
      </div>

      <div className={s.team}>
        <h2>Join Our Team</h2>
        <p>
          If you have a background in marketing and would like to help us bring
          Shadower to more communities, contact us.
        </p>

        <p>To do</p>
      </div>
    </PageLayout>
  );
}

export default withStyles(s)(CareersPage);
